export default {
  setData: (state, data) => {
    state.data = data;
  },
  setPlatformFeatures: (state, data) => {
    state.platformFeatures = data;
  },
  setVendors: (state, data) => {
    state.vendors = data;
  },
  setVendorProducts: (state, data) => {
    state.vendorProducts = data;
  },
};
